import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationStratalotTodoApiService } from './company-communication-stratalot-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationStratalotTodoApiService extends GeneratedCompanyCommunicationStratalotTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
